import useOnClickOutside from "@/hooks/useOnClickOutside";
import React, { PropsWithChildren, useRef } from "react";

type ActionModel = {
  text: string;
  value: string;
  icon?: React.ReactNode;
  onClick: () => void;
};

type Props = {
  options: ActionModel[];
  id?: string;
};

const UserActionSheet = ({
  options,
  id,
  children,
}: PropsWithChildren<Props>) => {
  const ref = useRef<HTMLDivElement>(null);
  const { show: showDropDown, setShow } = useOnClickOutside(ref);

  const toggle = () => {
    setShow(!showDropDown);
  };

  return (
    <div className="relative" id={id} ref={ref}>
      <div className="cursor-pointer" onClick={toggle}>
        {children}
      </div>
      <div className="absolute top-0 right-10 shadow-xl z-10 min-w-[100px] bg-[#ffff]">
        {showDropDown &&
          options &&
          options.map((c, index) => (
            <div
              className="flex items-center px-2 py-2 cursor-pointer"
              key={`Action${index + 1}`}
              onClick={() => {
                c.onClick();
                toggle();
              }}
            >
              {c.icon} <span className="ml-4">{c.text}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default UserActionSheet;
